import { render, staticRenderFns } from "./purchaseOrderReorderTable.vue?vue&type=template&id=96926392&"
import script from "./purchaseOrderReorderTable.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderReorderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports